import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../../../UI/Loader';


export default class PageLoader extends React.Component {
    static propTypes = {
        isLoading: PropTypes.bool,
        children: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.node),
            PropTypes.node,
            PropTypes.array
        ])
    }

    static defaultProps = {
        isLoading: false,
        children: []
    };

    render() {
        if (this.props.isLoading) {
            return <Loader />
        }

        return (
            <React.Fragment>
                {this.props.children}
            </React.Fragment>
        )
    }
};

